import { createRouter, createWebHistory } from "vue-router";

import AppLayout from "@/layouts/AppLayout.vue";
import DashboardView from "@/views/DashboardView.vue";
import LoginView from "@/views/LoginView.vue";
import SettingsView from "@/views/SettingsView.vue";
import UsersView from "@/views/UsersView.vue";
import AuditLogView from "@/views/AuditLogView.vue";
import TeamMembersView from "@/views/TeamMembersView.vue";
import PlanConfigView from "@/views/PlanConfigView.vue";
import OrderRecordsView from "@/views/OrderRecordsView.vue";
import CommissionRecordsView from "@/views/CommissionRecordsView.vue";
import { authGuard } from "./guards";

const router = createRouter({
  history: createWebHistory("/"),
  routes: [
    {
      path: "/login",
      name: "login",
      component: LoginView,
      meta: { title: "登录" },
    },
    {
      path: "/",
      component: AppLayout,
      children: [
        {
          path: "",
          redirect: "/dashboard",
        },
        {
          path: "/dashboard",
          name: "dashboard",
          component: DashboardView,
          meta: { requiresAuth: true, title: "数据概览" },
        },
        {
          path: "/settings",
          name: "settings",
          component: SettingsView,
          meta: { requiresAuth: true, title: "品牌与功能" },
        },
        {
          path: "/users",
          name: "users",
          component: UsersView,
          meta: { requiresAuth: true, title: "用户管理" },
        },
        {
          path: "/team-members",
          name: "team-members",
          component: TeamMembersView,
          meta: { requiresAuth: true, title: "团队成员" },
        },
        {
          path: "/audit",
          name: "audit",
          component: AuditLogView,
          meta: { requiresAuth: true, title: "操作日志" },
        },
        {
          path: "/plan-configs",
          name: "plan-configs",
          component: PlanConfigView,
          meta: { requiresAuth: true, title: "套餐销售配置" },
        },
        {
          path: "/orders",
          name: "orders",
          component: OrderRecordsView,
          meta: { requiresAuth: true, title: "交易记录" },
        },
      ],
    },
  ],
});

router.beforeEach(authGuard);

export default router;
